var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("小程序暂不支持SIS,请复制链接后打开浏览器访问")]),_c('h3',[_vm._v(_vm._s(_vm.h5_applet_address))]),_c('el-button',{staticClass:"mainButton",attrs:{"type":"primary"},on:{"click":function($event){return _vm.copyUrl()}}},[_vm._v("复制链接")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }